
export default {
  name: 'EoPerson',
  props: {
    /**
     * Hyperlink to url, page or anchor tag
     */
    to: {
      type: String,
      default: null,
    },
    /**
     * Prefetches the page behind the link
     */
    prefetch: {
      type: Boolean,
      default: true,
    },
    /**
     * Target for the link: (_self) (_blank)
     */
    target: {
      type: String,
      default: '_self',
    },
    /**
     * URL of an image to show
     */
    image: {
      type: String,
      default: null,
    },
    /**
    * Url of an overlay image to show 
    */
    overlayImage: {
      type: String,
      default: null,
    },
    /**
     * Name of the person
     */
    name: {
      type: String,
      default: null,
    },
    /**
     * Show name above title
     */
    nameFirst: {
      type: Boolean,
      default: false,
    },
    /**
     * Make name of person bold
     */
    nameProminent: {
      type: Boolean,
      default: false,
    },
    /**
     * Heading above the name
     */
    title: {
      type: String,
      default: null,
    },
    /**
     * Emailaddress of the person
     */
    email: {
      type: String,
      default: null,
    },
    /**
     * Phone number of the person
     */
    phone: {
      type: String,
      default: null,
    },
    /**
     * SOON DEPRECATED: Description about this person
     */
    description: {
      type: String,
      default: null,
    },
  },
  computed: {
    cClasses () {
      return {
        'eo-person': true,
        'is-clickable': !!this.to,
        'is-name-prominent': this.nameProminent,
        'is-name-first': this.nameFirst,
      }
    },
    dynamicLinkTag () {
      if (this.to) {
        if (
          this.to.startsWith('https://') ||
          this.to.startsWith('http://') ||
          this.to.startsWith('tel:') ||
          this.to.startsWith('mailto:') ||
          this.to.startsWith('whatsapp:') ||
          this.to.startsWith('#') ||
          this.target.toLowerCase() === '_parent' ||
          this.target.toLowerCase() === '_top'
        ) {
          return 'a'
        }
        if (this.$root.$options.components.NuxtLink) {
          return 'nuxt-link'
        } else if (this.$root.$options.components.RouterLink) {
          return 'router-link'
        } else {
          return 'a'
        }
      }
      return 'div'
    },
    cHref () {
      if (this.dynamicLinkTag === 'a' || this.dynamicLinkTag === 'nuxt-link' || this.dynamicLinkTag === 'router-link') {
        return this.to || null
      } else {
        return null
      }
    },
  },
}
